import { lotteryService } from "./api";
import { RESULTS_HISTORY_LIMIT, applyResultsSearch } from "./resultsMapper";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Parámetros de GET /lottery/results/list_results/ para una lotería/fecha.
 * Las loterías del catálogo traen UUID (lottery_id, exacto); las que solo
 * aparecen en resultados usan el nombre como id (lottery, icontains).
 */
export function buildResultsQuery({ lotteryId = "", date = "" } = {}, lotteries = []) {
  const params = { limit: RESULTS_HISTORY_LIMIT };
  if (date) params.fecha = date;
  if (lotteryId) {
    const id = String(lotteryId);
    if (UUID_RE.test(id)) {
      params.lottery_id = id;
    } else {
      const lottery = lotteries.find((l) => String(l.id) === id);
      params.lottery = lottery?.name || id;
    }
  }
  return params;
}

/**
 * Consulta de resultados filtrada en el backend (lotería + fecha), para poder
 * encontrar sorteos que ya no están entre los últimos 200. Número y serie se
 * filtran sobre lo que devuelve el servidor. Público: no requiere sesión.
 *
 * @returns {Promise<{ ok: boolean, matches: object[], message?: string, error?: string }>}
 */
export async function searchLotteryResults(payload = {}, lotteries = []) {
  const hasNumber = String(payload.numero || "").replace(/\D/g, "").length >= 4;
  if (!payload.date && !hasNumber) {
    return { ok: false, error: "Selecciona una fecha de sorteo.", matches: [] };
  }

  try {
    const res = await lotteryService.listResults(buildResultsQuery(payload, lotteries));
    if (!res.ok) {
      return {
        ok: false,
        error: "No se pudieron consultar los resultados. Intenta de nuevo.",
        matches: [],
      };
    }
    return applyResultsSearch(res.data, payload, lotteries);
  } catch (err) {
    console.error("[searchLotteryResults]", err);
    return {
      ok: false,
      error: "Error de conexión al consultar resultados.",
      matches: [],
    };
  }
}
